import { useEffect, useState } from 'react';
import { Source, Layer, Popup, useMap } from 'react-map-gl/mapbox';
import { API_URL } from '../../../config';
import educationIcon from '../../../assets/education-building.png';
import { authFetch } from '../../../utils';

const EducationBuildingsLayer = ({ visible }) => {
  const [geojsonData, setGeojsonData] = useState(null);
  const [popupInfo, setPopupInfo] = useState(null);
  const { current: map } = useMap();

  useEffect(() => {
    if (!map) return;

    // Verifica si el icono ya está cargado
    if (!map.hasImage('education-icon')) {
      map.loadImage(educationIcon, (error, image) => {
        if (error) {
          console.error('Error al cargar el icono:', error);
          return;
        }
        if (!map.hasImage('education-icon')) {
          map.addImage('education-icon', image);
        }
      });
    }
  }, [map]);


  useEffect(() => {
    if (!visible) return;

    authFetch(`${API_URL}emergency-layers/education-buildings`)
      .then(res => res.json())
      .then(data => setGeojsonData(data))
      .catch(err => console.error('Error al cargar centros educativos:', err));
  }, [visible]);

  useEffect(() => {
    if (!map || !geojsonData) return;

    const handleClick = e => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['education-buildings-symbol']
      });

      if (features.length > 0) {
        const feature = features[0];
        const coords = feature.geometry.coordinates;
        const props = feature.properties;

        setPopupInfo(null);

        setTimeout(() => {
          setPopupInfo({
            longitude: coords[0],
            latitude: coords[1],
            name: props.nombre,
            direccion: props.direccion,
            responsable: props.responsable,
            telefono: props.telefono
          });
        }, 0);
      } else {
        setPopupInfo(null);
      }
    };

    map.on('click', handleClick);
    return () => map.off('click', handleClick);
  }, [map, geojsonData]);

  if (!visible || !geojsonData) return null;

  return (
    <>
      <Source id="education-buildings" type="geojson" data={geojsonData}>
        <Layer
          id="education-buildings-symbol"
          type="symbol"
          layout={{
            'icon-image': 'education-icon',
            'icon-size': 0.25, // Ajusta el tamaño según lo que necesites
            'icon-offset': [0, -1],
            'icon-anchor': 'top',
            'icon-allow-overlap': true,
            'icon-ignore-placement': true
          }}
        />

      </Source>

      {popupInfo && (
        <Popup
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          anchor="top"
          onClose={() => setPopupInfo(null)}
        >
          <div style={{ lineHeight: '1.4em' }}>
            <div><strong>Nombre:</strong> {popupInfo.name}</div>
            <div><strong>Dirección:</strong> {popupInfo.direccion}</div>
            <div><strong>Responsable:</strong> {popupInfo.responsable}</div>
            <div><strong>Teléfono:</strong> {popupInfo.telefono}</div>
          </div>
        </Popup>
      )}
    </>
  );
};

export default EducationBuildingsLayer;
